// extracted by mini-css-extract-plugin
export default {"header":"HomeRelease_header__dZjXj","left":"HomeRelease_left__CEcX0","right":"HomeRelease_right__xz7PQ","body":"HomeRelease_body__bJVFd"};